// extracted by mini-css-extract-plugin
export var alignLeft = "H_rd d_fp d_bG d_dv";
export var alignCenter = "H_bP d_fq d_bD d_dw";
export var alignRight = "H_rf d_fr d_bH d_dx";
export var verticalDottedFirstComponent = "H_vZ";
export var wrap = "H_v0 d_bJ d_cb";
export var topPadding = "H_v1 d_cX";
export var compContent = "H_v2 d_w";
export var last = "H_v3";
export var box = "H_v4 d_cr";
export var boxWrapper = "H_v5 d_w d_bz";
export var boxWrapperFirst = "H_v6 d_w d_bz";